<template>
  <div class="home-container">
    <section class="d-flex flex-column-reverse flex-lg-row justify-content-end justify-content-lg-between align-items-start align-items-lg-center row-gap-2">
      <div class="d-flex gap-3" ref="getterButtonsWrappper">
        <primaryButtonComponent v-for="(data, i) of getterButtonsArray" buttonType="button" :mode="data.mode" @click="getterButtonsSubmitHandler(data.routeSetValue)" class="large-text font-weight-600" buttonWidth="200px">
          <template v-slot:content>
            {{ data.content }}
          </template>
        </primaryButtonComponent>
      </div>
      <secondaryButton buttonType="button" class="large-text font-weight-600" buttonWidth="max-content" paddingX="15px" @click="activateModalMode('addSupporter')">
          <template v-slot:content>
              {{filteringPagingInfo.supportersMode == 2? "ახალი წევრი": "ახალი მხარდამჭერი"}}
          </template>
      </secondaryButton>
    </section>
    <section class="supporters-map-section">
      <div class="d-flex justify-content-stretch w-100 gap-5" style="height: 100%;">
        <commonStatisticsList listWidth="230px" :showOptionalHeader="true" :title="filteringPagingInfo.supportersMode == 2?'წევრები ქალაქების მიხედვით':'მხარდამჭერები ქალაქების მიხედვით'">
          <template v-slot:optionalHeader>
            <form @submit.prevent="submitSupportersMapFilters">
              <input v-model="supportersMapFiltersInfoObj.search" @input="supportersMapFiltersInputHandler()" autocomplete="off" name="list-search-input" id="list-search-input" type="text" class="primary-input extra-light-text" placeholder="ძებნა"/>
            </form>
          </template>
          <template v-slot:list>
            <template v-for="(cityObj, i) of mapListArray">
              <li v-if="cityObj.regionID == 0 && cityObj.cityID == 1" class="d-flex align-items-center justify-content-between gap-3 w-100 py-1 px-2">
                <h5 class="extra-gray-color text-ellipsis text-start light-text">{{cityObj.city}}</h5>
                <p class="before-extra-large-text">{{ cityObj.resp_count }}</p>
              </li>
              <li v-else @click="getSupporterDetailsForMap(cityObj)" :class="[{'active': cityObj.isChoosen}, {'ps-3': cityObj.cityID == 1}, 'map-list-element', 'common-transition', 'd-flex', 'align-items-center', 'justify-content-between', 'gap-3' ,'w-100', 'py-1', 'px-2', 'border-radius-10', 'cursor-pointer']">
                <h5 class="extra-gray-color common-transition text-ellipsis text-start light-text">{{cityObj.city}}</h5>
                <p class="before-extra-large-text">{{ cityObj.resp_count }}</p>
              </li>
            </template>
          </template>
        </commonStatisticsList>
        <div class="respodents-map-wrapper border-radius-10 w-100" style="height: 100%;">
          <markerMapComponent height="100%" :markersInfo="markerInfoArray" :zoomOn="zoomedMarkerIndex" :allowUnZoom="allowMapUnZoom" :zoomLevel="10"/>
        </div>
      </div>
    </section>
    <section class="common-statistics">
      <commonStatisticsBlock>
        <template v-slot:title>
          <div class="d-flex align-items-center gap-2">
            <h6 class="light-text extra-gray-color">{{ filteringPagingInfo.supportersMode == 2? "სულ წევრები": "სულ მხარდამჭერები"}}</h6>
          </div>
        </template>
        <template v-slot:correspondingInfo>
          <p class="statistics-info extra-black-color">{{ this.commonStatisticsObj?.respodentAll_count??"0" }}</p>
        </template>
        <template v-slot:chart>
            <commonStatisticsBarChart :mode="commonStatisticsBarColors[(3) % 4]"/>
        </template>
      </commonStatisticsBlock>
      <commonStatisticsBlock>
        <template v-slot:title>
          <h6 class="light-text extra-gray-color">1 თვის ჭრილში</h6>
        </template>
        <template v-slot:correspondingInfo>
          <p class="statistics-info extra-black-color">{{ this.commonStatisticsObj?.last30dayCount??"0" }}</p>
        </template>
        <template v-slot:chart>
          <commonStatisticsBarChart :mode="commonStatisticsBarColors[(4) % 4]"/>
        </template>
      </commonStatisticsBlock>
      <commonStatisticsBlock>
        <template v-slot:title>
          <h6 class="light-text extra-gray-color">ვერიფიცირებული</h6>
        </template>
        <template v-slot:correspondingInfo>
          <p class="statistics-info extra-black-color">{{ this.commonStatisticsObj?.isVerifiedCount??"0" }}</p>
        </template>
        <template v-slot:chart>
          <commonStatisticsBarChart :mode="commonStatisticsBarColors[(2) % 4]"/>
        </template>
      </commonStatisticsBlock>
      <commonStatisticsBlock>
        <template v-slot:title>
          <h6 class="light-text extra-gray-color">რაოდენობა</h6>
        </template>
        <template v-slot:correspondingInfo>
          <div class="d-flex flex-column row-gap-1 extra-black-color">
            <p class="large-text font-size-600">ქალი: <span class="before-extra-large-text">{{ this.commonStatisticsObj?.femaleCount??"0" }}</span></p>
            <p class="large-text font-size-600">კაცი: <span class="before-extra-large-text">{{ this.commonStatisticsObj?.maleCount??"0" }}</span></p>
          </div>
        </template>
        <template v-slot:chart>
          <commonStatisticsBarChart :mode="commonStatisticsBarColors[(1) % 4]"/>
        </template>
      </commonStatisticsBlock>
    </section>
    <section class="d-flex flex-column gap-3 align-items-center">
      <h4 class="extra-large-text align-self-start">
        {{filteringPagingInfo.supportersMode == 2?'წევრები':'მხარდამჭერები'}}
      </h4>
      <div :class="['d-flex', 'flex-column', 'align-items-stretch', 'search-container', 'w-100', 'align-items-start']">
        <div class="d-flex justify-content-between align-items-center">
          <excelFileDownloadComponent @igniteDownload="igniteDownload" @abortDownload="abortDetailedStatisticsDownload" btnPaddingX="8px" btnPaddingY="6px" excelFileName="respodents" :namesArray="['supporters', 'members']" :jsonToExcelArray="jsonToExcelArray" :downloadInAction="downloadInAction" :canAbortDownload="true"/>
          <button @click="resetSupportersFilters()" type="button" class="extra-light-text extra-red-color me-2" style="font-weight: 600; background-color: transparent;">გასუფთავება</button>
        </div>
        <hr style="margin: 0.5em 0 1em;">
        <form class="secondary-search-container-form" @submit.prevent="submitSupportersFilters">
          <fieldset class="filters-wrapper">
            <input v-model="supportersFiltersInfoObj.search" name="search-input" id="search-input" type="text" class="primary-input extra-light-text" placeholder="ძებნა"/>
            <Multiselect v-for="(data, i) of seenMultiselectArray" name="seen" id="seen" v-model="supportersFiltersInfoObj.seen" :options="data.options" :mode="data.mode"
              :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
              :hideSelected="false" locale="ge" :canDeselect="true" :canClear="true" :required="false"
              class="extra-light-text light-blue-color custom-multiselect without-max-width" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled" insert/>
            <Multiselect ref="cityID" v-model="supportersFiltersInfoObj.cityID" :options="this.supportersFiltersMultiselectsArray[1].options" :mode="this.supportersFiltersMultiselectsArray[1].mode"
              :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1" id="cityID"
              :hideSelected="true" locale="ge" @select="(value, option) => allowNextMultiselect(value, 2, true, true, supportersFiltersMultiselectsArray, supportersFiltersInfoObj)" @deselect="() => blockNextMultiselects(2, supportersFiltersMultiselectsArray, supportersFiltersInfoObj)" @clear="() => blockNextMultiselects(2, supportersFiltersMultiselectsArray, supportersFiltersInfoObj)"
              class="extra-light-text light-blue-color" autocomplete="off" :placeholder="this.supportersFiltersMultiselectsArray[1].placeholder" :disabled="this.supportersFiltersMultiselectsArray[1].isDisabled" insert/>
            <Multiselect ref="regionID" v-model="supportersFiltersInfoObj.regionID" :options="this.supportersFiltersMultiselectsArray[2].options" :mode="this.supportersFiltersMultiselectsArray[2].mode"
              :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
              :hideSelected="true" locale="ge" @select="(value, option) => allowNextMultiselect(value, 3, true, true, supportersFiltersMultiselectsArray, supportersFiltersInfoObj)" @deselect="() => blockNextMultiselects(3, supportersFiltersMultiselectsArray, supportersFiltersInfoObj)" @clear="() => blockNextMultiselects(3, supportersFiltersMultiselectsArray, supportersFiltersInfoObj)"
              class="extra-light-text light-blue-color" autocomplete="off" :placeholder="this.supportersFiltersMultiselectsArray[2].placeholder" :disabled="this.supportersFiltersMultiselectsArray[2].isDisabled" insert/>
            <Multiselect ref="districtID" v-model="supportersFiltersInfoObj.districtID" :options="this.supportersFiltersMultiselectsArray[3].options" :mode="this.supportersFiltersMultiselectsArray[3].mode"
              :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
              :hideSelected="true" locale="ge"
              class="extra-light-text light-blue-color" autocomplete="off" :placeholder="this.supportersFiltersMultiselectsArray[3].placeholder" :disabled="this.supportersFiltersMultiselectsArray[3].isDisabled" insert/>
            <datePicker :datePickerMode="1" :rangeVmodelKeeper="supportersFiltersInfoObj.date" indicator="dateFilter" :isRequired="false" @update="handleDate"/>
            <Multiselect v-for="(data, i) of supportersFiltersAgeRangesMultiselectArray" name="ageRangeID" id="ageRangeID" v-model="supportersFiltersInfoObj.ageRange" :options="data.options" :mode="data.mode"
              :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
              :hideSelected="true" locale="ge" :canDeselect="true" :canClear="true" :required="false"
              class="extra-light-text light-blue-color" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled" insert/>
            <Multiselect v-for="(data, i) of supportersFiltersGenderMultiselectArray" name="genderID" id="genderID" v-model="supportersFiltersInfoObj.genderID" :options="data.options" :mode="data.mode"
              :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
              :hideSelected="true" locale="ge" :canDeselect="true" :canClear="true" :required="false"
              class="extra-light-text light-blue-color" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled" insert/>
            <Multiselect v-if="this.filteringPagingInfo.supportersMode == 2" v-for="(data, i) of respodentStatusMultiselectArray" name="filtersrespodent_statusID" id="filtersrespodent_statusID" v-model="supportersFiltersInfoObj.respodent_statusID" :options="data.options" :mode="data.mode"
              :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
              :hideSelected="true" locale="ge" :canDeselect="false" :canClear="false" :required="false"
              class="extra-light-text light-blue-color" autocomplete="off" :placeholder="data.placeholder" :disabled="false" insert/>
              <fieldset class="w-100 right-side">
                <div class="primary-helper-card d-flex align-items-center justify-content-center extra-black-color" style="border-radius: 5px;">
                  <p class="light-text font-weight-600">
                    რაოდენობა
                    <span class="extra-green-color">{{ supportersPagingInfo.total }}</span>
                  </p>
                </div>
                <button type="submit" class="secondary-submit-btn d-flex align-items-center justify-content-center">
                  <p class="extra-light-text">
                    გაფილტვრა
                  </p>
                </button>
              </fieldset>
          </fieldset>
        </form>
      </div>
    </section>
    <section class="main-info-section d-flex flex-column gap-3 align-items-center" style="margin-top: -0.7em;">
      
      <div class="border-radius-20 w-100" style="background-color: var(--secondary-background-color); border-radius: 25px;">
        <div class="common-table-container common-scrollbar mt-2">
          <table class="common-tablee">
            <thead>
              <tr>
                <th></th>
                <th class="light-text light-blue-color">სახელი გვარი</th>
                <th class="light-text light-blue-color">ასაკი</th>
                <th class="light-text light-blue-color">ტელეფონი</th>
                <th class="light-text light-blue-color">ოლქი</th>
                <th class="light-text light-blue-color">უბანი</th>
                <th class="light-text light-blue-color">საარჩ.უბანი</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(supporter, i) of supportersArray">
                <tr class="light-black-color light-text">
                  <td class="d-flex justify-content-start">
                    <img v-if="supporter.photo" :src="supporter.photo" alt="profile photo" style="width: 33px; height: 33px; border-radius: 50%;">
                    <div v-else style="width: 33px; height: 33px; border-radius: 50%; background-color: var(--light-blue);"></div>
                  </td>
                  <td><p>{{ `${supporter.name} ${supporter.surename}` }}</p></td>
                  <td><p>{{supporter.age}}</p></td>
                  <td><p>{{ supporter.phone }}</p></td>
                  <td><p>{{ supporter.district.region.city.city??supporter.district.region.region }}</p></td>
                  <td><p>{{ supporter.district.region.city.city?supporter.district.region.region:'--------' }}</p></td>
                  <td><p>{{ supporter.district.district }}</p></td>
                  <td style="padding: 0; width: min-content;">
                    <img v-if="supporter.seen == 1" src="@\assets\images\blue_Seen.svg" alt="seen">
                    <img v-else src="@\assets\images\disabled_seen.svg" alt="not seen">               
                  </td>
                  <td style="padding: 0; width: min-content;">
                    <primaryButtonComponent buttonWidth="max-content" class="extra-light-text" paddingY="8px" paddingX="10px" :mode="2" @click="activateModalMode('seeDetailedRespondent', supporter)">
                      <template v-slot:content>
                        დეტალურად
                      </template>
                    </primaryButtonComponent>
                  </td>
                  <td style="padding: 0; width: min-content;">
                    <div class="d-flex gap-2 align-items-center justify-content-end" style="width: min-content;">
                      <primaryButtonComponent buttonWidth="max-content" class="extra-light-text" paddingY="8px" paddingX="10px" :mode="2" @click="getRespodentComments(supporter.respodentID), activateModalMode('addComment', supporter)">
                        <template v-slot:content>
                          კომენტარი
                        </template>
                      </primaryButtonComponent>
                      <button class="ms-2" style="height: min-content;">
                        <img src="@/assets/images/tableDeleteButton.svg" alt="delete button" @click="activateModalMode('delete', supporter)">
                      </button>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <vue-awesome-paginate
          :total-items="supportersPagingInfo.total"
          :items-per-page="supportersPagingInfo.limit"
          :max-pages-shown="4"
          v-model="supportersPagingInfo.offset"
          :hide-prev-next-when-ends="true"
          @click="paginationClickHandler"
          class="my-4"
        />
      </div>
    </section>
  </div>
  <primaryModalComponent :showModal="showModal" maxHeight="781px" maxWidth="846px" @closeModal="triggerModal">
        <template v-slot:modal-content>
          <div class="d-flex flex-column align-items-center gap-4">
            <div class="d-flex align-items-center justify-content-between w-100">
              <div>
                <img v-if="modalMode == 'seeDetailedRespondent'" @click="activateModalMode('correctInfo', null)" src="@\assets\images\correctionButton.svg" alt="edit button" class="cursor-pointer">
                <img v-if="modalMode == 'correctInfo'" @click="activateModalMode('seeDetailedRespondent', this.addOrCorrectSupportersObj)" src="@\assets\images\correctionButton.svg" alt="edit button" class="cursor-pointer">

              </div>
              <h5 class="before-extra-large-text">
                {{ modalTitle }}
              </h5>
              <div></div>
            </div>
            <form v-if="modalMode == 'addSupporter' && !checkedPersonObj.district" @submit.prevent="getElectionUsers" class="modal-form-grid-wrapper verification-form w-100">
              <fieldset class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
                <label for="name" class="ms-2">სახელი</label>
                <input v-model="checkPersonObj.name" type="text" autocomplete="off" name="name" id="name" required placeholder="სახელი" class="blue-part-input large-text">
              </fieldset>
              <fieldset class="d-flex flex-column align-items-end gap-1 light-gray-color light-text">
                <label for="surname" class="ms-2">გვარი</label>
                <input v-model="checkPersonObj.surename" type="text" autocomplete="off" name="surname" id="surname" required placeholder="გვარი" class="blue-part-input large-text">
              </fieldset>
              <fieldset class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
                <label for="bdate" class="ms-2">დაბადების თარიღი</label>
                <datePicker :datePickerMode="2" :singleVmodelKeeper="checkPersonObj.bdate" indicator="bdate" :isRequired="true" @update="updateCheckPersonObjBdate"/>

              </fieldset>
              <div v-if="!isSending" class="d-flex align-items-end">
                <primaryButtonComponent  :disabled="isSending" v-if="modalMode == 'addSupporter'" buttonWidth="max-content" buttonType="submit" class="large-text" paddingY="8px">
                    <template v-slot:content>
                        ძიება
                    </template>
                </primaryButtonComponent>
              </div>
              <div v-if="isSending" style="grid-column: 1 / 3;" class="d-flex justify-content-center pt-3">
                <div class="spinner-border text-dark" role="status">
                </div>
              </div>
            </form>
            <div v-if="checkedPersonObj.district && modalMode == 'addSupporter'" class="d-flex gap-2 align-items-start p-2 border-radius-10 common-box-shadow" style="max-height: min-content">
              <img :src="checkedPersonObj.IMAGER" alt="" style="width: 100%; max-width: 75px; aspect-ratio: 1 / 1;">
                <ul class="d-flex flex-column w-100 large-text extra-black-color">
                  <li class="text-start">
                    <h6 class="font-weight-600">სახელი გვარი: <span class="font-weight-500">{{ `${checkedPersonObj.name} ${checkedPersonObj.surename}` }}</span></h6>
                  </li>
                  <li class="text-start">
                    <h6 class="font-weight-600">დაბადების თარიღი: <span class="font-weight-500">{{ checkedPersonObj.bdate }}</span></h6>
                  </li>
                  <li class="text-start">
                    <h6 class="font-weight-600">უბანი: <span class="font-weight-500">{{ checkedPersonObj.district }}</span></h6>
                  </li>
                  <li class="text-start">
                    <h6 class="font-weight-600">მისამართი: <span class="font-weight-500">{{ checkedPersonObj.address }}</span></h6>
                  </li>
                </ul>
                <primaryButtonComponent @click="checkPerson(null)" :disabled="isSending" buttonWidth="max-content" buttonType="button" class="large-text" paddingY="8px">
                    <template v-slot:content>
                        გაუქმება
                    </template>
                </primaryButtonComponent>
            </div>
            <ul v-if="checkPersonOptions.length > 0 && !checkedPersonObj.district && modalMode == 'addSupporter'" class="w-100 d-flex flex-column">
              <li v-for="(data, i) of checkPersonOptions" class="d-flex gap-2 align-items-start p-2 border-radius-10 common-box-shadow common-scrollbar common-vertical-overflow" style="max-height: 100px">
                <img :src="data.IMAGER" alt="" style="width: 100%; max-width: 75px; aspect-ratio: 1 / 1;">
                <ul class="d-flex flex-column w-100 large-text extra-black-color">
                  <li class="text-start">
                    <h6 class="font-weight-600">უბანი: <span class="font-weight-500">{{ data.district }}</span></h6>
                  </li>
                  <li class="text-start">
                    <h6 class="font-weight-600">მისამართი: <span class="font-weight-500">{{ data.address }}</span></h6>
                  </li>
                </ul>
                <primaryButtonComponent @click="checkPerson(i)" :disabled="isSending" buttonWidth="max-content" buttonType="button" class="large-text" paddingY="8px">
                    <template v-slot:content>
                        არჩევა
                    </template>
                </primaryButtonComponent>
              </li>
            </ul>
            <div v-if="(modalMode == 'addSupporter' && checkedPersonObj.district) || modalMode == 'correctInfo' || modalMode == 'seeDetailedRespondent'" class="d-flex flex-column w-100 align-items-start">
              <div v-if="this.openedAddOrCorrectSupportersObj?.photo && (modalMode == 'correctInfo' || modalMode == 'seeDetailedRespondent')" class="w-100 d-flex justify-content-center">
                <mediaShowDownload :showDownloadButton="false" :showDeleteButton="false" :photoURl="this.openedAddOrCorrectSupportersObj.photo??null"/>
              </div>
              <form @submit.prevent="addOrCorrectSupporter" class="modal-form-grid-wrapper verification-form w-100">
                <fieldset v-if="modalMode == 'correctInfo' || modalMode == 'seeDetailedRespondent'" class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
                  <label for="name">სახელი<span class="extra-red-color">*</span></label>
                  <input v-model="addOrCorrectSupportersObj.name" :disabled="modalMode == 'seeDetailedRespondent'" type="text" autocomplete="off" name="name" id="name" required placeholder="სახელი" class="blue-part-input large-text">
                </fieldset>
                <fieldset v-if="modalMode == 'correctInfo' || modalMode == 'seeDetailedRespondent'" class="d-flex flex-column align-items-end gap-1 light-gray-color light-text">
                  <label for="surname">გვარი<span class="extra-red-color">*</span></label>
                  <input v-model="addOrCorrectSupportersObj.surename" :disabled="modalMode == 'seeDetailedRespondent'" type="text" autocomplete="off" name="surname" id="surname" required placeholder="გვარი" class="blue-part-input large-text">
                </fieldset>
                <fieldset v-if="modalMode == 'correctInfo' || modalMode == 'seeDetailedRespondent'" class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
                  <label for="bdate">დაბადების თარიღი<span class="extra-red-color">*</span></label>
                  <!-- <input v-model="addOrCorrectSupportersObj.bdate" :disabled="modalMode == 'seeDetailedRespondent'" type="date" autocomplete="off" name="bdate" id="bdate" required class="blue-part-input large-text"> -->
                  <datePicker class="custom-dp__main" :datePickerMode="2" :disabled="modalMode == 'seeDetailedRespondent'" :singleVmodelKeeper="addOrCorrectSupportersObj.bdate" indicator="correctionBdate" :isRequired="true" @update="updatecCorrectionRespodent"/>
                </fieldset>
                <fieldset :class="['d-flex', 'flex-column', {'align-items-start': modalMode == 'addSupporter'}, {'align-items-end': modalMode == 'correctInfo' || modalMode == 'seeDetailedRespondent'} ,'gap-1', 'light-gray-color', 'light-text']">
                  <label for="age">ასაკი<span class="extra-red-color">*</span></label>
                  <input v-model="addOrCorrectSupportersObj.age" :disabled="modalMode == 'seeDetailedRespondent'" type="number" autocomplete="off" name="age" id="age" required placeholder="ასაკი" class="blue-part-input large-text">
                </fieldset>
                <fieldset :class="['d-flex', 'flex-column', {'align-items-end': modalMode == 'addSupporter'}, {'align-items-start': modalMode == 'correctInfo' || modalMode == 'seeDetailedRespondent'} ,'gap-1', 'light-gray-color', 'light-text']">
                  <label for="privateNumber">პირადი ნომერი<span v-if="this.filteringPagingInfo.supportersMode == 2" class="extra-red-color">*</span></label>
                  <input v-model="addOrCorrectSupportersObj.personal_number" :disabled="modalMode == 'seeDetailedRespondent'" type="text" autocomplete="off" name="privateNumber" id="privateNumber" :required="!((modalMode == 'addSupporter') || (modalMode == 'correctInfo' && addOrCorrectSupportersObj.respodent_typeID == false))" placeholder="პირადი ნომერი" class="blue-part-input large-text">
                </fieldset>
                <fieldset :class="['d-flex', 'flex-column', {'align-items-start': modalMode == 'addSupporter'}, {'align-items-end': modalMode == 'correctInfo' || modalMode == 'seeDetailedRespondent'} ,'gap-1', 'light-gray-color', 'light-text']">
                  <label for="phone">ტელეფონის ნომერი<span class="extra-red-color">*</span></label>
                  <input v-model="addOrCorrectSupportersObj.phone" :disabled="modalMode == 'seeDetailedRespondent'" type="text" autocomplete="off" name="phone" id="phone" required placeholder="(9 სიმბოლო)ტელეფონის ნომერი" class="blue-part-input large-text">
                </fieldset>
                <fieldset :class="['d-flex', 'flex-column', {'align-items-end': modalMode == 'addSupporter'}, {'align-items-start': modalMode == 'correctInfo' || modalMode == 'seeDetailedRespondent'} ,'gap-1', 'light-gray-color', 'light-text']">
                  <label for="email">email</label>
                  <input v-model="addOrCorrectSupportersObj.email" :disabled="modalMode == 'seeDetailedRespondent'" type="email" autocomplete="off" name="email" id="email" placeholder="email" class="blue-part-input large-text">
                </fieldset>
                <fieldset v-if="modalMode == 'correctInfo' || modalMode == 'seeDetailedRespondent'" class="d-flex flex-column align-items-end gap-1 light-gray-color light-text">
                  <label for="address">იურიდიული მისამართი<span class="extra-red-color">*</span></label>
                  <input v-model="addOrCorrectSupportersObj.address" :disabled="modalMode == 'seeDetailedRespondent'" type="text" autocomplete="off" name="address" id="address" required placeholder="სახელი" class="blue-part-input large-text">
                </fieldset>
                <fieldset class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
                  <label for="address">ფაქტობრივი მისამართი</label>
                  <input v-model="addOrCorrectSupportersObj.address_fact" :disabled="modalMode == 'seeDetailedRespondent'" type="text" autocomplete="off" name="address" id="address" placeholder="ფაქტობრივი მისამართი" class="blue-part-input large-text">
                </fieldset>
                <fieldset :class="['d-flex', 'flex-column', 'align-items-end' ,'gap-1', 'light-gray-color', 'light-text']">
                  <label for="modalGenderID">სქესი<span class="extra-red-color">*</span></label>
                  <Multiselect v-for="(data, i) of genderMultiselectArray" name="modalGenderID" id="modalGenderID" v-model="addOrCorrectSupportersObj.genderID" :options="data.options" :mode="data.mode"
                    :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                    :hideSelected="true" locale="ge" :canDeselect="false" :canClear="false" :required="true"
                    class="extra-light-text light-blue-color" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled || modalMode == 'seeDetailedRespondent'" insert/>
                </fieldset>
                <!-- <fieldset :class="['d-flex', 'flex-column', 'align-items-end','gap-1', 'light-gray-color', 'light-text']">
                  <label for="goingTypeID" id="goingTypeID-assist" class="ms-2">სტატუსი</label>
                  <Multiselect v-for="(data, i) of goingTypesMultiselectArray" name="goingTypeID" id="goingTypeID" v-model="addOrCorrectSupportersObj.going_typeID" :options="data.options" :mode="data.mode"
                    :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                    :hideSelected="true" locale="ge" :canDeselect="false" :canClear="false" :required="true"
                    class="extra-light-text light-blue-color" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled || modalMode == 'seeDetailedRespondent'" insert/>
                </fieldset> -->
                <!-- <fieldset :class="['d-flex', 'flex-column', 'align-items-start','gap-1', 'light-gray-color', 'light-text']">
                  <label for="moodID" id="moodID-assist" class="ms-2">განწყობა</label>
                  <Multiselect v-for="(data, i) of moodTypesMultiselectArray" name="moodID" id="moodID" v-model="addOrCorrectSupportersObj.moodID" :options="data.options" :mode="data.mode"
                    :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                    :hideSelected="true" locale="ge" :canDeselect="false" :canClear="false" :required="true"
                    class="extra-light-text light-blue-color" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled || modalMode == 'seeDetailedRespondent'" insert/>
                </fieldset> -->
                <fieldset v-if="modalMode == 'correctInfo' || modalMode == 'seeDetailedRespondent'" class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
                  <label for="modalCityID">ქალაქი<span class="extra-red-color">*</span></label>
                  <Multiselect  v-model="additionVmodelsForCorrction.cityID" id="modalCityID" name="modalCityID" :options="this.additionCorrectionVmodelsMultiselectsArray[1].options" :mode="this.additionCorrectionVmodelsMultiselectsArray[1].mode"
                    :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1" :required="true"
                    :hideSelected="true" locale="ge" @select="(value, option) => allowNextMultiselect(value, 2, true, true, additionCorrectionVmodelsMultiselectsArray, additionVmodelsForCorrction)" @deselect="() => blockNextMultiselects(2, additionCorrectionVmodelsMultiselectsArray, additionVmodelsForCorrction)" @clear="() => blockNextMultiselects(2, additionCorrectionVmodelsMultiselectsArray, additionVmodelsForCorrction)"
                    class="extra-light-text light-blue-color" autocomplete="off" :placeholder="this.additionCorrectionVmodelsMultiselectsArray[1].placeholder" :disabled="this.additionCorrectionVmodelsMultiselectsArray[1].isDisabled || modalMode == 'seeDetailedRespondent'" insert/>
                </fieldset>
                <fieldset v-if="modalMode == 'correctInfo' || modalMode == 'seeDetailedRespondent'" class="d-flex flex-column align-items-end gap-1 light-gray-color light-text">
                  <label for="modalRegionID">უბანი<span class="extra-red-color">*</span></label>
                  <Multiselect v-model="additionVmodelsForCorrction.regionID" id="modalRegionID" name="modalRegionID" :options="this.additionCorrectionVmodelsMultiselectsArray[2].options" :mode="this.additionCorrectionVmodelsMultiselectsArray[2].mode"
                    :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1" :required="true"
                    :hideSelected="true" locale="ge" @select="(value, option) => allowNextMultiselect(value, 3, true, true, additionCorrectionVmodelsMultiselectsArray, additionVmodelsForCorrction)" @deselect="() => blockNextMultiselects(3, additionCorrectionVmodelsMultiselectsArray, additionVmodelsForCorrction)" @clear="() => blockNextMultiselects(3, additionCorrectionVmodelsMultiselectsArray, additionVmodelsForCorrction)"
                    class="extra-light-text light-blue-color" autocomplete="off" :placeholder="this.additionCorrectionVmodelsMultiselectsArray[2].placeholder" :disabled="this.additionCorrectionVmodelsMultiselectsArray[2].isDisabled || modalMode == 'seeDetailedRespondent'" insert/>
                </fieldset>
                <fieldset v-if="modalMode == 'correctInfo' || modalMode == 'seeDetailedRespondent'" class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
                  <label for="modalDistrictID">უბნის ნომერი<span class="extra-red-color">*</span></label>
                  <Multiselect v-model="additionVmodelsForCorrction.districtID" id="modalDistrictID" name="modalDistrictID" :options="this.additionCorrectionVmodelsMultiselectsArray[3].options" :mode="this.additionCorrectionVmodelsMultiselectsArray[3].mode"
                    :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1" :required="true"
                    :hideSelected="true" locale="ge"
                    class="extra-light-text light-blue-color" autocomplete="off" :placeholder="this.additionCorrectionVmodelsMultiselectsArray[3].placeholder" :disabled="this.additionCorrectionVmodelsMultiselectsArray[3].isDisabled || modalMode == 'seeDetailedRespondent'" insert/>
                </fieldset>
                <fieldset v-if="this.filteringPagingInfo.supportersMode == 2 && (modalMode == 'correctInfo' || modalMode == 'seeDetailedRespondent')" :class="['d-flex', 'flex-column', 'align-items-end' ,'gap-1', 'light-gray-color', 'light-text']">
                  <label for="modalrespodent_statusID">სტატუსი<span class="extra-red-color">*</span></label>
                  <Multiselect v-for="(data, i) of respodentStatusMultiselectArray" name="modalrespodent_statusID" id="modalrespodent_statusID" v-model="addOrCorrectSupportersObj.respodent_statusID" :options="data.options" :mode="data.mode"
                    :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                    :hideSelected="true" locale="ge" :canDeselect="false" :canClear="false" :required="true"
                    class="extra-light-text light-blue-color" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled || modalMode == 'seeDetailedRespondent'" insert/>
                </fieldset>
                <fieldset v-if="(modalMode == 'correctInfo' || modalMode == 'seeDetailedRespondent')" :class="['d-flex', 'gap-2', 'align-items-center', {'justify-content-end': this.filteringPagingInfo.supportersMode == 1}, {'justify-content-start': this.filteringPagingInfo.supportersMode == 2}]">
                  <input :disabled="modalMode == 'seeDetailedRespondent'" name="checkAsMember" id="checkAsMember" type="checkbox" v-model="addOrCorrectSupportersObj.respodent_typeID">
                  <label for="checkAsMember" class="extra-light-text light-blue-color">მოინიშნოს როგორც წევრი</label>
                </fieldset>
                <article v-if="modalMode == 'correctInfo' || modalMode == 'seeDetailedRespondent'" style="grid-column: 1 / 3;" class="d-flex flex-column gap-2 align-items-start w-100 primary-helper-card">
                  <ul class="d-flex flex-row align-items-center justify-content-between extra-light-text light-blue-color w-100 flex-wrap">
                    <li class="d-flex flex-column align-items-start">
                      <h6 class="light-text font-weight-600 light-black-color text-start">დაამატა</h6>
                      <p v-if="this.openedAddOrCorrectSupportersObj.added_by" class="text-start">{{ `${this.openedAddOrCorrectSupportersObj.added_by.name} ${this.openedAddOrCorrectSupportersObj.added_by.surename}` }}</p>
                      <p v-else class="text-start">---------------</p>
                    </li>
                    <li>
                      <h6 class="light-text font-weight-600 light-black-color text-end">თარიღი</h6>
                      <p v-if="this.openedAddOrCorrectSupportersObj.reg_date" class="text-end">{{ this.openedAddOrCorrectSupportersObj.reg_date }}</p>
                      <p v-else class="text-end">---------------</p>
                    </li>
                  </ul>
                </article>
                <div v-if="!isSending" class="button-wrapper d-flex justify-content-center w-100">
                  <secondaryButton :disabled="isSending" v-if="modalMode == 'addSupporter'" buttonWidth="max-content" buttonType="submit" class="large-text mt-4">
                    <template v-slot:content>
                      დამატება
                    </template>
                  </secondaryButton>
                  <primaryButtonComponent :disabled="isSending" v-if="modalMode == 'correctInfo'" buttonWidth="max-content" buttonType="submit" class="large-text mt-4">
                    <template v-slot:content>
                      დადასტურება
                    </template>
                  </primaryButtonComponent>
                </div>
                <div v-if="isSending" style="grid-column: 1 / 3;" class="d-flex justify-content-center pt-3">
                  <div class="spinner-border text-dark" role="status">
                  </div>
                </div>
              </form>
            </div>
            <div v-if="modalMode == 'addComment'" class="w-100 gap-2" style="display: grid; grid-template-columns: 1fr; grid-template-rows: min-content auto; height: 100%;">
              <form @submit.prevent="addComment" class="w-100 d-flex flex-column align-items-center">
                <fieldset class="w-100">
                  <textarea style="max-width: none;" v-model="commentVmodel" placeholder="დაამატეთ კომენტარი" required id="comment" name="comment" cols="30" maxlength="150" class="blue-part-input large-text" rows="5"></textarea>
                </fieldset>
                <primaryButtonComponent paddingY="10px" paddingX="17px" buttonType="submit" class="light-text mt-2">
                  <template v-slot:content>
                      დადასტურება
                  </template>
                </primaryButtonComponent>
              </form>
              <ul class="respodent-comments-wrapper w-100 d-flex flex-column align-items-center gap-2 common-vertical-overflow common-scrollbar">
                <li v-if="commentInfo.length > 0" v-for="(commentObj, i) of commentInfo" class="primary-helper-card d-flex flex-column align-items-start gap-2 extra-black-color light-text w-100">
                  <div class="d-flex align-items-center justify-content-between w-100">
                    <h6 class="large-text font-weight-600 extra-black-color">{{ `${commentObj?.added_by.name} ${commentObj?.added_by.surename}` }}</h6>
                    <span class="extra-light-text">{{ `${commentObj?.comment_date}` }}</span>
                  </div>
                  <div class="d-flex flex-column align-items-start align-items-start w-100">
                    <p class="light-text text-start"> {{ `${commentObj?.comment}` }}</p>
                  </div>
                </li>
                <li v-else class="primary-helper-card d-flex flex-column align-items-start gap-2 extra-black-color light-text">
                  <h6 class="light-text extra-black-color">კომენტარები არ დაწერილა</h6>
                </li>
              </ul>
            </div>
            <div v-if="modalMode == 'delete'" class="d-flex align-items-center justify-content-center gap-3">
              <primaryButtonComponent @click="respodentDeleteHandler" buttonType="submit" class="large-text mt-4">
                    <template v-slot:content>
                        წაშლა
                    </template>
              </primaryButtonComponent>
              <primaryButtonComponent @click="triggerModal(false)" :mode="1" buttonType="submit" class="large-text mt-4">
                    <template v-slot:content>
                        გაუქმება
                    </template>
              </primaryButtonComponent>
            </div>
          </div>
        </template>
    </primaryModalComponent>
</template>


<script>
// @ is an alias to /src
import primaryButtonComponent from "@/components/primaryButtonComponent.vue"
import secondaryButton from "@/components/secondaryButton.vue"
import commonStatisticsBlock from "@/components/commonStatisticsBlock.vue"
import commonStatisticsList from "@/components/commonStatisticsList.vue"
import searchFilterBarComponent from "@/components/search-filterBarComponent.vue"
import primaryModalComponent from "@/components/primaryModalComponent.vue"
import commonStatisticsBarChart from "@/components/commonStatisticsBarChart.vue"
import Multiselect from '@vueform/multiselect'
import linearSearchingMultiSearch from "@/components/linearSearchingMultiSearch.vue";
import excelFileDownloadComponent from "@/components/excelFileDownloadComponent.vue";
import markerMapComponent from "@/components/markerMapComponent.vue"
import datePicker from "@/components/datePicker.vue"
import mediaShowDownload from "@/components/mediaShowDownload.vue"
// vueDate picker is imported in main.js globally
import { isProxy, toRaw } from 'vue';


export default {
  name: "HomeView",
  data(){
    return {
      date: null,
      // for router >>
      activatedFilterMode: 0,
      filteringPagingInfo: {
        supportersMode: null,
        supporterssearch: "",
        supporterscityID: null,
        supportersregionID: null,
        supportersdistrictID: null,
        supportersOffset: null,
        supportersgenderID: null,
        supportersageRange: null,
        supportersstartDateInputValue: null,
        supportersendDateInputValue: null,
        supportersseen: null,
        supportersrespodent_statusID: null,
        mapsearch: null,
      },
      supportersFiltersInfoObj: {
        cityID:null,
        regionID: null,
        districtID:null,
        search: "",
        genderID: null,
        ageRange: null,
        date: [],
        startDateInputValue: null,
        endDateInputValue: null,
        seen: null,
        respodent_statusID: null,
      },
      supportersMapFiltersInfoObj: {
        search: null,
      },

      getterButtonsArray: [
        {
          content: "მხარდამჭერები",
          mode: 0,
          routeSetValue: 1,
        },
        {
          content: "წევრები",
          mode: 1,
          routeSetValue: 2,
        }
      ],
      mapListArray: [],
      isSupporterDetailsForMapComing: false,
      inputTimeStamp: null,
      choosenMapListElementObj: null,
      markerInfoArray: null,
      zoomedMarkerIndex: null,
      allowMapUnZoom: false,
      // for supporters filters >>
      jsonToExcelArray: [],
      downloadInAction: false,
      abortController: null,
      supportersPagingInfo: {
        limit: 10,
        offset: 1,
        total: 0,
      },
      supportersFiltersMultiselectsArray: [
        {},
        {
          placeholder: "ოლქი",
          options: [],
          mode: "single",
          isDisabled: false,
        },
        {
          placeholder: "უბანი",
          options: [],
          mode: "single",
          isDisabled: true,
        },
        {
          placeholder: "უბნის ნომერი",
          options: [],
          mode: "single",
          isDisabled: true,
        },
      ],
      supportersFiltersGenderMultiselectArray: [
        {
          placeholder: "სქესი",
          options: [],
          mode: "single",
          isDisabled: false,
        },
      ],
      supportersFiltersAgeRangesMultiselectArray: [
        {
          placeholder: "ასაკი",
          options: [],
          mode: "single",
          isDisabled: false,
        },
      ],
      currentPage: 1,
      supportersArray: [],
      //  for common statistics >>
      commonStatisticsObj: {},
      commonStatisticsBarColors: [
          "green",
          "red",
          "orange",
          "blue",
      ],
      // for modal >>
      modalMode: null,
      showModal: false,
      modalTitle: "",
      commentVmodel: "",
      checkPersonObj: {
        name: "",
        surename: "",
        bdate: "",
      },
      addOrCorrectSupportersObj: {
        respodentID: null,
        IMAGER: "",
        name: "",
        surename: "",
        bdate: "",
        age: null,
        personal_number: "",
        phone: "",
        email: "",
        address: "",
        genderID: null,
        district: "",
        going_typeID: null,
        moodID: null,
        lat: null,
        lng: null,
        respodent_typeID: null,
        respodent_statusID: null,
        address_fact: null,
        seen: null,
      },
      openedAddOrCorrectSupportersObj: null,
      additionCorrectionVmodelsMultiselectsArray: [
        {},
        {
          placeholder: "ოლქი",
          options: [],
          mode: "single",
          isDisabled: false,
        },
        {
          placeholder: "უბანი",
          options: [],
          mode: "single",
          isDisabled: true,
        },
        {
          placeholder: "უბნის ნომერი",
          options: [],
          mode: "single",
          isDisabled: true,
        },
      ],
      additionVmodelsForCorrction: {
        cityID: null,
        regionID: null,
        districtID: null,
      },
      genderMultiselectArray: [
        {
          placeholder: "სქესი",
          options: [],
          mode: "single",
          isDisabled: false,
        },
      ],
      respodentStatusMultiselectArray: [
        {
          placeholder: "სტატუსი",
          options: [],
          mode: "single",
          isDisabled: false,
        },
      ],
      seenMultiselectArray: [
        {
          placeholder: "ნანახი",
          options: [
              {
                value: 1,
                label: {
                  ge: "ნანახი(კი)",
                  en: "yes"
                }
              },
              {
                value: 0,
                label: {
                  ge: "ნანახი(არა)",
                  en: "no"
                }
              }
          ],
          mode: "single",
          isDisabled: false,
        }
      ],
      // goingTypesMultiselectArray: [ //goingTypes<><>
      //   {
      //     placeholder: "სტატუსი",
      //     options: [],
      //     mode: "single",
      //     isDisabled: false,
      //   },
      // ],
      checkPersonOptions: [],
      checkedPersonObj: {
        IMAGER: "",
        name: null,
        surename: null,
        bdate: null,
        district: null,
        address: null,
      },
      // moodTypesMultiselectArray: [ moodTypes<><><>
      //   {
      //     placeholder: "განწყობა",
      //     options: [],
      //     mode: "single",
      //     isDisabled: false,
      //   },
      // ],
      respodentIDToBeDeleted: null,
      commentInfo: [],
      // << for modal
      isSending: false,
    }
  },
  components: {
    primaryButtonComponent,
    secondaryButton,
    commonStatisticsBlock,
    commonStatisticsList,
    searchFilterBarComponent,
    primaryModalComponent,
    commonStatisticsBarChart,
    Multiselect,
    linearSearchingMultiSearch,
    excelFileDownloadComponent,
    markerMapComponent,
    datePicker,
    mediaShowDownload,
  },
  mounted() {
    this.removeAriaHidden();
    this.routerMountMovement(this.$route);
    this.getGenders();
    this.getAgeRanges();
    // this.getGoingTypes();
    // this.getMoods();
    this.getRespodentStatuses();
    this.$watch(() => this.supportersFiltersMultiselectsArray[1].options, (newOptions, oldOptions) => {
        this.supportersFiltersInfoObj.cityID = this.supportersFiltersInfoObj.cityID;
        
        if(this.supportersFiltersInfoObj.cityID){
          this.allowNextMultiselect(this.supportersFiltersInfoObj.cityID, 2, false, false, this.supportersFiltersMultiselectsArray, this.supportersFiltersInfoObj);
            
        }
      },
      { deep: true }
    );
    this.$watch(() => this.supportersFiltersMultiselectsArray[2].options, (newOptions, oldOptions) => {
        this.supportersFiltersInfoObj.regionID = this.supportersFiltersInfoObj.regionID;
        if(this.supportersFiltersInfoObj.regionID){
            this.allowNextMultiselect(this.supportersFiltersInfoObj.regionID, 3, false, false, this.supportersFiltersMultiselectsArray, this.supportersFiltersInfoObj);
        }
      },
      { deep: true }
    );
    this.$watch(() => this.supportersFiltersMultiselectsArray[3].options, (newOptions, oldOptions) => {
        this.supportersFiltersInfoObj.regionID = this.supportersFiltersInfoObj.regionID;
      },
      { deep: true }
    );
    // >>>>>>>>>>>>>>>> 
    this.$watch(() => this.additionCorrectionVmodelsMultiselectsArray[2].options, (newOptions, oldOptions) => {
        this.additionVmodelsForCorrction.regionID = this.additionVmodelsForCorrction.regionID;
        if(this.additionVmodelsForCorrction.regionID){
          this.allowNextMultiselect(this.additionVmodelsForCorrction.regionID, 3, false, false, this.additionCorrectionVmodelsMultiselectsArray, this.additionVmodelsForCorrction);
        }
      },
      { deep: true }
    );
    this.$watch(() => this.additionCorrectionVmodelsMultiselectsArray[3].options, (newOptions, oldOptions) => {
        this.additionVmodelsForCorrction.regionID = this.additionVmodelsForCorrction.regionID;
        this.seenOnRespodent(this.addOrCorrectSupportersObj);
      },
      { deep: true }
    );
  },
  watch: {
    'additionVmodelsForCorrction.cityID'(newVal){
      if(newVal && this.additionVmodelsForCorrction.cityID){
        this.allowNextMultiselect(this.additionVmodelsForCorrction.cityID, 2, false, false, this.additionCorrectionVmodelsMultiselectsArray, this.additionVmodelsForCorrction);
      }
    }
  },
  beforeRouteUpdate(to, from, next){
    let isQueriesValid = this.getInfoFromRoute(to);
    if(isQueriesValid){
      if(this.activatedFilterMode == 0){
        this.getterButtonsManagementHandler(this.filteringPagingInfo.supportersMode??1);
      }else if(this.activatedFilterMode == 1){
        this.manageSupportersFilters();
      }else if(this.activatedFilterMode == 2){
        this.manageSupportersMapFilters();
      }
      next(true);
    }else{
      next(false);
      this.$helper.showSwal("არასწორი მისამართი", "error", "");
    }
    this.activatedFilterMode = 0;
  },
  methods: {
    
    routerMountMovement(to){
      let isQueriesValid = this.getInfoFromRoute(to);
      
      if(isQueriesValid){
        this.getterButtonsManagementHandler(this.filteringPagingInfo.supportersMode??1);
        this.getCitiesAll([this.supportersFiltersMultiselectsArray, this.additionCorrectionVmodelsMultiselectsArray]);

      }else{
        this.$router.replace(this.$route.path);
        this.$helper.showSwal("არასწორი მისამართი", "error", "");
      }
      this.activatedFilterMode = 0;
    },
    getInfoFromRoute(to){
      Object.keys(this.filteringPagingInfo).forEach((key) => {
        this.filteringPagingInfo[key] = to.query[key]?decodeURIComponent(to.query[key].replace(/%/g, '%25')):null;
      })
      
      let isQueriesValid = Object.keys(this.filteringPagingInfo).every((key) => {
        if(key == "supporterssearch" || key == "mapsearch"){
          return this.$helper.checkJustOptionalString(this.filteringPagingInfo[key]??"");
        }else if(key == "supportersstartDateInputValue" || key == "supportersendDateInputValue"){
          return this.$helper.checkDateWithRegex(this.filteringPagingInfo[key]??"");
        }else if(this.filteringPagingInfo[key] == null){
          return true;
        }else{
          return this.$helper.checkOptionalNumber(this.filteringPagingInfo[key]);
        }
      });
      
      return isQueriesValid;
    },
    updateCheckPersonObjBdate(date){
      this.checkPersonObj.bdate = date;
    },
    updatecCorrectionRespodent(date){
      this.addOrCorrectSupportersObj.bdate = date;
    },
    handleDate(modelDate){
      if(modelDate){
      
        this.supportersFiltersInfoObj.startDateInputValue = modelDate[0]??null;
        if(modelDate.length > 1){
          this.supportersFiltersInfoObj.endDateInputValue = modelDate[1]??null;
        }else{
          this.supportersFiltersInfoObj.endDateInputValue = null;
        }
      }else{
        this.supportersFiltersInfoObj.startDateInputValue = null;
        this.supportersFiltersInfoObj.endDateInputValue = null;
      }
      
    },
    checkPerson(index){
      if(index != null){
        this.checkedPersonObj = {...this.checkPersonOptions[index]};
        
        this.addOrCorrectSupportersObj.age = this.$helper.calculateAge(this.checkedPersonObj.bdate);
      }else{
        this.checkedPersonObj = {};
        Object.keys(this.addOrCorrectSupportersObj).forEach((key) => {
          if(typeof(this.addOrCorrectSupportersObj[key]) == "string"){
            this.addOrCorrectSupportersObj[key] = "";
          }else{
            this.addOrCorrectSupportersObj[key] = null;
          }
        })
      }
    },
    getSupportersInfo(){
      this.$store.dispatch("getSupportersInfo", {respodent_typeID: this.filteringPagingInfo.supportersMode??1, cityID: this.supportersFiltersInfoObj.cityID, regionID: this.supportersFiltersInfoObj.regionID, districtID: this.supportersFiltersInfoObj.districtID}).then((response) => {
        let respodentAll_count = 0;
        let last30dayCount = 0;
        let isVerifiedCount = 0;
        let maleCount = 0;
        let femaleCount = 0;
        response.data.forEach((infoObj) => {
          respodentAll_count += infoObj.resp_count;
          if(Number(infoObj.last_30_day) > 0){
            last30dayCount += Number(infoObj.last_30_day);
          }
          if(infoObj.is_verified == 1){
            isVerifiedCount += infoObj.resp_count;
          }
          if(infoObj.genderID == 1){
            maleCount += infoObj.resp_count;
          }else if(infoObj.genderID == 0){
            femaleCount += infoObj.resp_count;
          }
        });
        
        this.commonStatisticsObj = {
          respodentAll_count,
          last30dayCount,
          isVerifiedCount,
          maleCount,
          femaleCount,
        };
      });
    },
    async getRespodent(){
      let customAgeRange;
      let ageRangeOptions;
      if(this.supportersFiltersAgeRangesMultiselectArray[0].options.length > 0){
        ageRangeOptions = this.supportersFiltersAgeRangesMultiselectArray[0].options;
      }else{
        await this.$store.dispatch("getAgeRanges").then((response) => {
          let tempArray = [];
          for(let range of response.data){
            if(range.agerangeID != 1){
              tempArray.push({
                  value: range.agerangeID,
                  label: {
                    ge: range.age_range,
                    en: range.age_range,
                  },
              });
            }
          }
          ageRangeOptions = tempArray;
        });
      }
      customAgeRange =  ageRangeOptions.find((ageRangeObj) => {
        if(ageRangeObj.value != 1){
          return ageRangeObj.value == this.supportersFiltersInfoObj.ageRange;
        }else{
          return false;
        }
      })?.label?.en;
      
      let cutomDateRange;
      if(this.supportersFiltersInfoObj.startDateInputValue && this.supportersFiltersInfoObj.endDateInputValue){
        cutomDateRange = `${this.supportersFiltersInfoObj.startDateInputValue}_${this.supportersFiltersInfoObj.endDateInputValue}`;
      }
      
      await this.$store.dispatch("getRespodent", {respodent_typeID: this.filteringPagingInfo.supportersMode??1, limit: this.supportersPagingInfo.limit, offset: this.supportersPagingInfo.offset - 1,
        ...this.supportersFiltersInfoObj, genderID: this.supportersFiltersInfoObj.genderID??null,  ageRange: customAgeRange, text: this.supportersFiltersInfoObj.search, dateRange: cutomDateRange,
      }).then((response) => {
        this.supportersArray = response.data[0];
        this.supportersPagingInfo.total = response.data[1];
      });
    },
    
    async igniteDownload(){
      this.abortController = new AbortController();
      let firstArray = [];
      let secondArray = [];
      this.jsonToExcelArray = [];
      let customAgeRange =  this.supportersFiltersAgeRangesMultiselectArray[0].options.find((ageRangeObj) => {
        if(ageRangeObj.value != 1){
          return ageRangeObj.value == this.supportersFiltersInfoObj.ageRange;
        }else{
          return false;
        }
      })?.label?.en;
      let cutomDateRange;
      if(this.supportersFiltersInfoObj.startDateInputValue && this.supportersFiltersInfoObj.endDateInputValue){
        cutomDateRange = `${this.supportersFiltersInfoObj.startDateInputValue}_${this.supportersFiltersInfoObj.endDateInputValue}`;
      }
      await Promise.all([
        this.$store.dispatch("getRespodent", {...this.supportersFiltersInfoObj, genderID: this.supportersFiltersInfoObj.genderID??null,  ageRange: customAgeRange, text: this.supportersFiltersInfoObj.search, dateRange: cutomDateRange,
          respodent_typeID: 1, limit: Number.MAX_SAFE_INTEGER, offset: 0, signal: this.abortController.signal}),
        this.$store.dispatch("getRespodent", {...this.supportersFiltersInfoObj, genderID: this.supportersFiltersInfoObj.genderID??null,  ageRange: customAgeRange, text: this.supportersFiltersInfoObj.search, dateRange: cutomDateRange,
          respodent_typeID: 2, limit: Number.MAX_SAFE_INTEGER, offset: 0, signal: this.abortController.signal}),
      ]).then((response) => {
        firstArray.push([
          "სახელი",
          "გვარი",
          "ასაკი",
          "დაბადების თარიღი",
          "სქესი",
          "იურიდიული მისამართი",
          "ფაქტობრივი მისამართი",
          "პირადი ნოემრი",
          "ტელეფონის ნომერი",
          "email",
          "დამატების თარიღი",
          "დამატების პირი",
          "ვერიფიცირებული",
        ]);
        response[0].data[0].forEach((respodentObj) => {
          firstArray.push([
          respodentObj.name,
          respodentObj.surename,
          respodentObj.age,
          respodentObj.bdate,
          respodentObj.gender.gender,
          respodentObj.address,
          respodentObj.address_fact,
          respodentObj.personal_number,
          respodentObj.phone,
          respodentObj.email,
          respodentObj.reg_date,
          respodentObj?.added_by?.name?`${respodentObj.added_by.name} ${respodentObj.added_by.surename}`:"",
          respodentObj.is_verified?"კი":"არა",
          ]);
        });
        secondArray.push([
          "სახელი",
          "გვარი",
          "ასაკი",
          "დაბადების თარიღი",
          "სქესი",
          "მისამართი",
          "პირადი ნოემრი",
          "ტელეფონის ნომერი",
          "email",
          "დამატების თარიღი",
          "დამატების პირი",
          "ვერიფიცირებული",
          "სტატუსი",
        ]);
        response[1].data[0].forEach((respodentObj) => {
            secondArray.push([
            respodentObj.name,
            respodentObj.surename,
            respodentObj.age,
            respodentObj.bdate,
            respodentObj.gender.gender,
            respodentObj.address,
            respodentObj.personal_number,
            respodentObj.phone,
            respodentObj.email,
            respodentObj.reg_date,
            respodentObj?.added_by?.name?`${respodentObj.added_by.name} ${respodentObj.added_by.surename}`:"",
            respodentObj.is_verified?"კი":"არა",
            this.respodentStatusMultiselectArray[0].options.find((respodentStatusObj) => {
              if(respodentStatusObj.value == respodentObj.respodent_statusID){
                return true;
              }else{
                return false;
              }
            }).label.ge,
          ]);
        });
        this.jsonToExcelArray.push(firstArray);
        this.jsonToExcelArray.push(secondArray);
        this.downloadInAction = !this.downloadInAction;
        this.abortController = null;
      }).catch((error) => {
      }).finally(() => {
        this.abortController = null;
        this.jsonToExcelArray = [];
      });
    },
    abortDetailedStatisticsDownload(){
      this.abortController?.abort();
      this.abortController = null;
    },
    // getGoingTypes(){
    //   this.$store.dispatch("getGoingTypes").then((response) => {
    //     let tempArray = [];
    //     for(let goingType of response.data){
    //       tempArray.push({
    //           value: goingType.going_typeID,
    //           label: {
    //               ge: goingType.going_type,
    //               en: goingType.going_typeeng,
    //           },
    //       });
    //     }
    //     this.goingTypesMultiselectArray[0].options = tempArray;
    //   })
    // },
    getFinalPositionOfficeResult(finalResultObj){
      this.addOrCorrectSupportersObj[finalResultObj.sendName] = finalResultObj.value;
    },
    getAgeRanges(){
      this.$store.dispatch("getAgeRanges").then((response) => {
        let tempArray = [];
        for(let range of response.data){
          if(range.agerangeID != 1){
            tempArray.push({
              value: range.agerangeID,
              label: {
                ge: range.age_range,
                en: range.age_range,
              },
            });
          }

        }
        this.supportersFiltersAgeRangesMultiselectArray[0].options = tempArray;
      });
    },
    getGenders(){
      this.$store.dispatch("getGenders").then((response) => {
        let tempArray = [];
        for(let gender of response.data){
            tempArray.push({
                value: gender.genderID,
                label: {
                    ge: gender.gender,
                    en: gender.gendereng,
                },
            });
        }
        this.genderMultiselectArray[0].options = tempArray;
        this.supportersFiltersGenderMultiselectArray[0].options = tempArray;
      });
    },
    // getMoods(){
    //   this.$store.dispatch("getMoods").then((response) => {
    //     let tempArray = [];
    //     for(let mood of response.data){
    //         tempArray.push({
    //             value: mood.moodID,
    //             label: {
    //               ge: mood.mood,
    //               eng: mood.moodeng,
    //             },
    //         });
    //     }
            
    //     this.moodTypesMultiselectArray[0].options = tempArray;
    //   })
    // },
    getRespodentStatuses(){
      this.$store.dispatch("getRespodentStatuses").then((response) => {
        let tempArray = [];
        for(let statusObj of response.data){
          tempArray.push({
            value: statusObj.respodent_statusID,
            label: {
              ge: statusObj.respodent_status,
              eng: statusObj.respodent_statuseng,
            },
          });
        }
            
        this.respodentStatusMultiselectArray[0].options = tempArray;
      });
    },
    getElectionUsers(){
      // let isNameValid = this.$helper.checkJustString(this.checkPersonObj.name);
      // let isSurnameValid = this.$helper.checkJustString(this.checkPersonObj.surename);
      // let isDateValid = this.$helper.checkDateWithRegex(this.checkPersonObj.bdate);

      if(this.checkPersonObj.name && this.checkPersonObj.surename && this.checkPersonObj.bdate){
        let formattedBDate = this.checkPersonObj.bdate.split("-").reverse().join(".");
        this.isSending = true;
        this.checkPersonOptions = [];
        this.$store.dispatch("getElectionUsers", {name: this.checkPersonObj.name, surename: this.checkPersonObj.surename, bdate: formattedBDate}).then((response) => {
          this.checkPersonOptions = response.data;
          
        }).catch((error) => {
          if(error?.response?.status >= 422){
            this.$helper.showSwal("მოხდა შეცდომა", "error", "");
            setTimeout(() => {this.$router.go()}, 1500);
          }
        }).finally(() => {
          this.isSending = false;
        })
      }
    },
    respodentDeleteHandler(){
      this.$store.dispatch("deleteRespodent", {respodentID: this.respodentIDToBeDeleted}).then((response) => {
        if(response.status >= 200){
          this.$helper.showSwal( this.filteringPagingInfo.supportersMode == 2?"წევრი წარმატებით წაიშალა":"მხარდამჭერი წარმატებით წაიშალა", "success", "");
          this.triggerModal(false);
          if(this.supportersPagingInfo.offset == 1){
            this.getRespodent();
            this.getSupportersInfo();
            this.getCitiesWithSupporterCount();

          }else{
            this.$router.push({
              path: this.$route.path,
              query: {
                ...this.$route.query, 
                supportersOffset: 0,
              }
            });
          }
        }
      }).catch((error) => {
        if(error?.response?.status >= 400){
          this.$helper.showSwal("მოხდა შეცდომა", "error", "");
          setTimeout(() => {this.$router.go()}, 1500);
        }
      }).finally(() => {
        this.isSending = false;
      })
      
    },
    addSupporter(){
      let isDistrictValid;
      let foundDistrict;
      if(this.modalMode == "addSupporter"){
        this.addOrCorrectSupportersObj.name = this.checkedPersonObj.name;
        this.addOrCorrectSupportersObj.surename = this.checkedPersonObj.surename;
        this.addOrCorrectSupportersObj.bdate = this.checkedPersonObj.bdate;
        this.addOrCorrectSupportersObj.district = this.checkedPersonObj.district;
        this.addOrCorrectSupportersObj.address = this.checkedPersonObj.address;
        this.addOrCorrectSupportersObj.IMAGER = this.checkedPersonObj.IMAGER;
        // isDistrictValid = this.$helper.checkJustString(this.addOrCorrectSupportersObj.district);
      }else if(this.modalMode == "correctInfo"){
        foundDistrict = this.additionCorrectionVmodelsMultiselectsArray[3].options.find((districtObj) => {
          return districtObj.value == this.additionVmodelsForCorrction.districtID;
        })?.label?.ge;
        
        // isDistrictValid = this.additionVmodelsForCorrction.districtID?this.$helper.checkJustString(foundDistrict):false;
      }

      // let isNameValid = this.$helper.checkJustString(this.addOrCorrectSupportersObj.name);
      // let isSurnameValid = this.$helper.checkJustString(this.addOrCorrectSupportersObj.surename);
      // let isPersonal_numberValid = this.$helper.checkPersonalNumber(this.addOrCorrectSupportersObj.personal_number);
      // let isEmailValid = this.$helper.checkEmail(this.addOrCorrectSupportersObj.email);
      // let isDateValid = this.$helper.checkDateWithRegex(this.addOrCorrectSupportersObj.bdate);
      // let isAgeIdValid = this.$helper.checkNumber(this.addOrCorrectSupportersObj.age);
      // let isAddressValid = this.$helper.checkJustString(this.addOrCorrectSupportersObj.address);
      // let isPhoneValid = this.$helper.checkJustString(this.addOrCorrectSupportersObj.phone);
      // let isGenderIdValid = this.$helper.checkNumber(this.addOrCorrectSupportersObj.genderID);
      // let isGoingTypeIdValid = this.$helper.checkNumber(this.addOrCorrectSupportersObj.going_typeID);
      // let isMoodIDValid = this.$helper.checkNumber(this.addOrCorrectSupportersObj.moodID);
      // console.log(isNameValid);
      // console.log(isSurnameValid);
      // console.log(isPersonal_numberValid);
      // console.log(isAgeIdValid);
      // console.log(isAddressValid);
      // console.log(isPhoneValid);
      // console.log(isEmailValid);
      // console.log(isGenderIdValid);
      // console.log(isDistrictValid);
      // console.log(isGoingTypeIdValid);
      // console.log(isDateValid);
      // console.log(this.addOrCorrectSupportersObj);
      // console.log(this.additionVmodelsForCorrction.districtID);
      this.addOrCorrectSupportersObj.moodID = 1;
      this.addOrCorrectSupportersObj.going_typeID = 4;

      // !((modalMode == 'addSupporter') || (modalMode == 'correctInfo' && addOrCorrectSupportersObj.respodent_typeID == false))
      let isPersonalNumberRequired = this.modalMode == 'correctInfo' && this.addOrCorrectSupportersObj.respodent_typeID == true;
      let isPersonalNumberRequiredAndSet = isPersonalNumberRequired?this.addOrCorrectSupportersObj.personal_number:true;

      if(this.addOrCorrectSupportersObj.moodID && this.addOrCorrectSupportersObj.name && this.addOrCorrectSupportersObj.surename && isPersonalNumberRequiredAndSet 
        && this.addOrCorrectSupportersObj.bdate && (this.addOrCorrectSupportersObj.age || this.addOrCorrectSupportersObj.age === 0) && this.addOrCorrectSupportersObj.address && this.addOrCorrectSupportersObj.phone 
        && (this.addOrCorrectSupportersObj.genderID || this.addOrCorrectSupportersObj.genderID == 0) && (this.addOrCorrectSupportersObj.district || foundDistrict) && this.addOrCorrectSupportersObj.going_typeID){
        
        this.isSending = true;
        
        if(this.modalMode == "addSupporter"){
          this.$store.dispatch("addRespodent", {...this.addOrCorrectSupportersObj, respodent_typeID: this.filteringPagingInfo.supportersMode??1, respodent_statusID: 1, seen: 0}).then((response) => {
            
            if(response.status >= 201){
              this.$helper.showSwal( this.filteringPagingInfo.supportersMode == 2?"წევრი წარმატებით დაემატა":"მხარდამჭერი წარმატებით დაემატა", "success", "");
              this.triggerModal(false);
              this.getRespodent();
              this.getSupportersInfo();
              this.getCitiesWithSupporterCount();

            }
          }).catch((error) => {
            if(error?.response?.status == 422 && error.response.data[0] == "already.exists"){
              this.$helper.showSwal(`${error?.response?.data[1][0]?.respodent_type?.respodent_type} უკვე დამატებულია`, "error", "");
            }else if(error?.response?.status >= 400){
              this.$helper.showSwal("მოხდა შეცდომა", "error", "");
              // setTimeout(() => {this.$router.go()}, 1500);
            }
            this.triggerModal(false);
            this.getRespodent();
            this.getSupportersInfo();
            this.getCitiesWithSupporterCount();

          }).finally(() => {
            this.isSending = false;
          })
        }else if(this.modalMode == "correctInfo"){
          
          this.$store.dispatch("editRespodent", {...this.addOrCorrectSupportersObj, district: foundDistrict+" ", respodent_typeID: this.addOrCorrectSupportersObj.respodent_typeID == false?1:2, seen: 1}).then((response) => {
            if(response.status >= 200){
              this.$helper.showSwal( this.filteringPagingInfo.supportersMode == 2?"წევრი წარმატებით ჩასწორდა":"მხარდამჭერი წარმატებით ჩასწორდა", "success", "");
              this.triggerModal(false);
              this.getRespodent();
              this.getSupportersInfo();
              this.getCitiesWithSupporterCount();
            }
          }).catch((error) => {
            if(error?.response?.status >= 400){
              this.$helper.showSwal("მოხდა შეცდომა", "error", "");
              this.triggerModal(false);
              this.getRespodent();
              this.getSupportersInfo();
              this.getCitiesWithSupporterCount();
              // setTimeout(() => {this.$router.go()}, 1500);
            }
          }).finally(() => {
            this.isSending = false;
          })
        }
      }
      
    },
    seenOnRespodent(supporter){
      let foundDistrict = this.additionCorrectionVmodelsMultiselectsArray[3].options.find((districtObj) => {
        return districtObj.value == this.additionVmodelsForCorrction.districtID;
      })?.label?.ge;
      if(supporter.seen !== 1){
        this.$store.dispatch("editRespodent", {...supporter, seen: 1, district: foundDistrict+" ", respodent_typeID: this.addOrCorrectSupportersObj.respodent_typeID == false?1:2}).then(() => {
          this.openedAddOrCorrectSupportersObj.seen = 1;
        }).catch((error) => {});
      }
    },
    addComment(){
      this.$store.dispatch("addRespodentComments", {respodentID: this.openedAddOrCorrectSupportersObj.respodentID, comment: this.commentVmodel}).then((response) => {
        if(response.status == 201){
          this.$helper.showSwal("კომენტარი წარმატებით დაემატა", "success", "");
          this.triggerModal(false);
          this.getRespodent();
          this.getSupportersInfo();
          this.getCitiesWithSupporterCount();
        }
      }).catch((error) => {
        if(error.response.status >= 400){
          this.$helper.showSwal("მოხდა შეცდომა", "error", "");
          this.triggerModal(false);
          this.getRespodent();
          this.getSupportersInfo();
          this.getCitiesWithSupporterCount();
        }
      });
    },
    getRespodentComments(respodentID){
      this.$store.dispatch("getRespodentComments", respodentID).then((response) => {
        this.commentInfo = response.data;
      });
    },
    addOrCorrectSupporter(){
      if(this.modalMode == "addSupporter" || this.modalMode == "correctInfo"){
        this.addSupporter();
      }
    },
    activateModalMode(mode, supporterObj){
      this.modalMode = mode;

      
      if(this.modalMode == "seeDetailedRespondent"){
        this.modalTitle = "დეტალურად";
        this.clearModalInfo();
        // address, district, lat, lng
        this.openedAddOrCorrectSupportersObj = this.openedAddOrCorrectSupportersObj??supporterObj;
        
        Object.keys(this.addOrCorrectSupportersObj).forEach((key, index) => {
          if(key != "district" && key != "lat" && key != "lng" && key != "respodent_typeID"){
            this.addOrCorrectSupportersObj[key] = this.openedAddOrCorrectSupportersObj[key];
          }else if(key == "respodent_typeID"){
            this.addOrCorrectSupportersObj[key] = this.openedAddOrCorrectSupportersObj[key] == 1?false:true;
          }else if(key == "district"){
            this.additionVmodelsForCorrction.districtID = this.openedAddOrCorrectSupportersObj[key]?.districtID;
            this.additionVmodelsForCorrction.regionID = this.openedAddOrCorrectSupportersObj[key]?.region?.regionID;
            this.additionVmodelsForCorrction.cityID = this.openedAddOrCorrectSupportersObj[key]?.region?.city?.cityID;
          }
        })
        
      }else if(this.modalMode == "correctInfo"){
        this.modalTitle = "მონაცემების შესწორება";

      }else if(this.modalMode == "addSupporter"){
        this.clearModalInfo();
        this.modalTitle = this.filteringPagingInfo.supportersMode == 2? "ახალი წევრის დამატება":"ახალი მხარდამჭერის დამატება";
        
      }else if(this.modalMode == "delete"){
        this.modalTitle = "ნამდვილად გსურთ წაშლა?";
        this.respodentIDToBeDeleted = supporterObj.respodentID;
      }else if(this.modalMode == "addComment"){
        this.modalTitle = "კომენტარის დამატება";
        this.openedAddOrCorrectSupportersObj = supporterObj;
      }
      
      
      this.triggerModal(true);
    },

    clearModalInfo(){
      this.checkPerson(null);
      this.checkPersonOptions = [];
      Object.keys(this.checkPersonObj).forEach((key) => {
        if(typeof(this.checkPersonObj[key]) == "string"){
          this.checkPersonObj[key] = "";
        }else{
          this.checkPersonObj[key] = null;
        }
      })
      Object.keys(this.additionVmodelsForCorrction).forEach((key) => {
        this.additionVmodelsForCorrction[key] = null;
      });
      this.respodentIDToBeDeleted = null;
      this.commentInfo = [];
      // this.openedAddOrCorrectSupportersObj = null; removed from here because this is needed in modal navigation

    },
    triggerModal(Val){
      if(Val == false){
        
        this.clearModalInfo();
        this.modalMode = null;
        this.modalTitle = "";
        this.commentVmodel = "";
        this.openedAddOrCorrectSupportersObj = null;
      }
      this.showModal = Val;
      if(Val){
        setTimeout(() => {
          this.removeAriaHidden();
        }, 0);
      }
    },
    paginationClickHandler(value){
      this.activatedFilterMode = 1;
      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query, 
          supportersOffset: Number(value) - 1,
        }
      });
    },
    getterButtonsSubmitHandler(routeSetValue){
      
      this.activatedFilterMode = 0;
      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          supportersMode: routeSetValue,
          supportersOffset: 0,
        },
      });
    },
    getterButtonsManagementHandler(clickedButtonIndex){
      this.getterButtonsArray.forEach((element, index) => {
        if(element.routeSetValue == clickedButtonIndex){
          element.mode = 0;
        }else{
          element.mode = 1;
        }
      })
      
      this.manageSupportersFilters();
      this.manageSupportersMapFilters();
    },
    manageSupportersMapFilters(){
      
      Object.keys(this.supportersMapFiltersInfoObj).forEach((key) => {
        if(this.filteringPagingInfo[`map${key}`] && this.filteringPagingInfo[`map${key}`]?.length > 0){
          this.supportersMapFiltersInfoObj[key] = this.filteringPagingInfo[`map${key}`];
        }else{
          this.supportersMapFiltersInfoObj[key] = "";
        }
      })
      this.getCitiesWithSupporterCount();
    },
    getCitiesWithSupporterCount(){
      this.choosenMapListElementObj = null;
      this.allowMapUnZoom = true;
      this.zoomedMarkerIndex = null;
      this.markerInfoArray = null;
      this.$store.dispatch("getCitiesWithSupporterCount", {respodent_typeID: this.filteringPagingInfo.supportersMode??1, search: this.supportersMapFiltersInfoObj.search}).then((response) => {
        this.mapListArray = response.data;
      });
    },
    manageSupportersFilters(){
      Object.keys(this.supportersFiltersInfoObj).forEach((key) => {
        if(key == "search" || key == "startDateInputValue" || key == "endDateInputValue"){
          this.supportersFiltersInfoObj[key] = this.filteringPagingInfo[`supporters${key}`];
          
        }else if(key == "date"){

        }else if(this.filteringPagingInfo[`supporters${key}`]){
          
          this.supportersFiltersInfoObj[key] = Number(this.filteringPagingInfo[`supporters${key}`]);
        }else{
          this.supportersFiltersInfoObj[key] = this.filteringPagingInfo[`supporters${key}`];
        }
      })

      this.supportersFiltersInfoObj.date = this.supportersFiltersInfoObj.startDateInputValue?[this.supportersFiltersInfoObj.startDateInputValue??null, this.supportersFiltersInfoObj.endDateInputValue??null]:null;
      
      if(!this.supportersFiltersInfoObj.cityID){
        this.blockNextMultiselects(2, this.supportersFiltersMultiselectsArray, this.supportersFiltersInfoObj);
      }else if(!this.supportersFiltersInfoObj.regionID){
        this.blockNextMultiselects(3, this.supportersFiltersMultiselectsArray, this.supportersFiltersInfoObj);
      }

      if(this.supportersFiltersInfoObj.cityID){
        this.allowNextMultiselect(this.supportersFiltersInfoObj.cityID, 2, false, false, this.supportersFiltersMultiselectsArray, this.supportersFiltersInfoObj);
      }else if(this.supportersFiltersInfoObj.regionID){
        this.allowNextMultiselect(this.supportersFiltersInfoObj.cityID, 3, false, false, this.supportersFiltersMultiselectsArray, this.supportersFiltersInfoObj);
      }
      
      this.supportersPagingInfo.offset = this.filteringPagingInfo.supportersOffset?Number(this.filteringPagingInfo.supportersOffset) + 1:1;
      
      this.getRespodent();
      this.getSupportersInfo();
    },
    allowNextMultiselect(value, index, clear, blockNext, changingArray, filterVModelsArray){
      if(value){
        if(index == 1){
          this.getCities(value, clear, changingArray, filterVModelsArray);
        }else if(index == 2){
          this.getRegions(value, clear, changingArray, filterVModelsArray);
        }else if(index == 3){
          this.getDistricts(value, clear, changingArray, filterVModelsArray);
        }
      }
      
      if(index < changingArray.length - 1 && blockNext){
        this.blockNextMultiselects(index + 1, changingArray, filterVModelsArray);
      }
    },
    blockNextMultiselects(index, changingArray, filterVModelsArray){
          
      if(index >= changingArray.length){
        return;
      }
          
      changingArray[index].options = [];
      if(index == 1){
          filterVModelsArray.cityID = null;
          this.getCitiesAll([this.supportersFiltersMultiselectsArray]);
      }else if(index == 2){
          filterVModelsArray.regionID = null;
          changingArray[index].isDisabled = true;
      }else if(index == 3){
          filterVModelsArray.districtID = null;
          changingArray[index].isDisabled = true;
      }
      this.blockNextMultiselects(index + 1, changingArray, filterVModelsArray);
    },
    resetSupportersFilters(){
      Object.keys(this.supportersFiltersInfoObj).forEach((key) => {
        this.supportersFiltersInfoObj[key] = null;
      });
      this.submitSupportersFilters();
    },
    submitSupportersFilters(){
      let tempObj = {};
      if(this.$route.query.supportersOffset){
        tempObj.supportersOffset = 0;
      }
      Object.keys(this.supportersFiltersInfoObj).forEach((key) => {
        if((this.supportersFiltersInfoObj[key] || this.supportersFiltersInfoObj[key] === 0) && key != "date"){
          tempObj[`supporters${key}`] = this.supportersFiltersInfoObj[key];
        }
      })
      this.activatedFilterMode = 1;
      let filteredQueries = {};
      Object.keys(this.$route.query).forEach((queryKey) => {
        if(this.supportersFiltersInfoObj.hasOwnProperty(`${queryKey.slice(10)}`) && queryKey.startsWith("supporters")){
        }else{
          filteredQueries[queryKey] = this.$route.query[queryKey];
        }
      })
      
      this.$router.push({
        path: this.$route.path,
        query: {
            ...filteredQueries,
            ...tempObj,
        }
      });
    },
    zoomOnIndexMarker(index){
      this.allowMapUnZoom = false;
      this.zoomedMarkerIndex = index;
    },
    getSupporterDetailsForMap(cityObj){
      
      if(!this.isSupporterDetailsForMapComing){
        this.markerInfoArray = null;
        this.allowMapUnZoom = false;
        this.zoomedMarkerIndex = null;
        if(this.choosenMapListElementObj){
          this.choosenMapListElementObj.isChoosen = false;
        }
        cityObj.isChoosen = true;
        this.choosenMapListElementObj = cityObj;
        this.isSupporterDetailsForMapComing = true;
        this.$store.dispatch("supporterDetailsForMap", {respodent_typeID: this.filteringPagingInfo.supportersMode??1, cityID: cityObj.cityID, regionID: cityObj.regionID}).then((response) => {
          setTimeout(() => {
            this.isSupporterDetailsForMapComing = false;
          }, 500);
            let word = this.filteringPagingInfo.supportersMode == 2?"წევრები":"მხარდამჭერები";
            let tempObj = {};
            response.data.forEach((supporterObj) =>{
              if(tempObj[supporterObj.district.district]){
                tempObj[supporterObj.district.district].count++;
                tempObj[supporterObj.district.district].address = `${word}: ${tempObj[supporterObj.district.district].count}`;
              }else if(supporterObj.district.lat){
                tempObj[supporterObj.district.district] = {
                  name: (supporterObj?.district?.district)?supporterObj.district.district:"",
                  latLng: {
                    lat: Number(supporterObj.district.lat),
                    lng: Number(supporterObj.district.lng),
                    altitude: 0,
                  },
                  count: 1,
                  ID: `${supporterObj.districtID}`,
                };
                tempObj[supporterObj.district.district].address = `${word}: ${tempObj[supporterObj.district.district].count}`;
                tempObj[supporterObj.district.district].comment = "";
              }
            });
            
            this.markerInfoArray = Object.values(tempObj);
            if(this.markerInfoArray.length > 0){
              this.zoomOnIndexMarker(0);
            }
            
    
            // let tempArray = [];
            // for(let problem of response.data){
            //   if(problem?.district?.lat != null){
            //     tempArray.push({
            //       name: (problem?.district?.district)?problem.district.district:"",
            //       latLng: {
            //         lat: Number(problem.district.lat),
            //         lng: Number(problem.district.lng),
            //         altitude: 0,
            //       },
            //       // address: problem.address,
            //       comment: problem.comment,
            //       ID: problem.districtID,
            //     });
            //   }
            // }
          });
      }
    },
    supportersMapFiltersInputHandler(){
      this.inputTimeStamp = new Date().getTime();
      setTimeout(() => {
        if(this.inputTimeStamp && new Date().getTime() - this.inputTimeStamp >= 600){
          this.submitSupportersMapFilters();
        }
      }, 600);
    },
    submitSupportersMapFilters(){
      
      this.inputTimeStamp = null;
      this.choosenMapListElementObj = null;
      this.allowMapUnZoom = false;
      this.zoomedMarkerIndex = null;
      this.markerInfoArray = null;
      let tempObj = {};
      
      Object.keys(this.supportersMapFiltersInfoObj).forEach((key) => {
        if(this.supportersMapFiltersInfoObj[key]){
          tempObj[`map${key}`] = this.supportersMapFiltersInfoObj[key];
        }
      })

      this.activatedFilterMode = 2;
      let filteredQueries = {};
      Object.keys(this.$route.query).forEach((queryKey) => {
        if(this.supportersMapFiltersInfoObj.hasOwnProperty(`${queryKey.slice(3)}`) && queryKey.startsWith("map")){
        }else{
          filteredQueries[queryKey] = this.$route.query[queryKey];
        }
      })
      
      this.$router.push({
        path: this.$route.path,
        query: {
          ...filteredQueries,
          ...tempObj,
        }
      });
    },
    getDistricts(valueID, clear, changingArray, filterVModelsArray){
      this.$store.dispatch("getDistricts",valueID).then((response) => {
        let tempArray = [];
        for(let obj of response.data){
          tempArray.push({
            value: obj.districtID,
            label: {
              ge: obj?.district,
              en: obj?.district,
            },
          });
        }
        if(clear){
          filterVModelsArray.districtID = null;
        }
        changingArray[3].options = tempArray;
        changingArray[3].isDisabled = false;
      })
    },
    getRegions(valueID, clear, changingArray, filterVModelsArray){
      this.$store.dispatch("getRegions",valueID).then((response) => {
        
        let tempArray = [];
        for(let obj of response.data){
          tempArray.push({
            value: obj.regionID,
            label: {
              ge: `${obj.region} ${obj.pathID?`- ${obj.pathID}`:""}`,
              en: `${obj.regioneng} ${obj.pathID?`- ${obj.pathID}`:""}`,
            },
          });
        }
        if(clear){
          filterVModelsArray.regionID = null;
        }
        changingArray[2].options = tempArray;
        changingArray[2].isDisabled = false;
      })
    },
    getCitiesAll(changingArray){
      this.$store.dispatch("getCitiesAll").then((response) => {
        let tempArray = [];
        for(let obj of response.data){
          tempArray.push({
            value: obj.cityID,
            label: {
              ge: `${obj.city} ${obj.pathID?`- ${obj.pathID}`:""}`,
              en: `${obj.cityeng} ${obj.pathID?`- ${obj.pathID}`:""}`,
            },
          });
        }
        changingArray.forEach((destArray) => {
          destArray[1].options = tempArray;
          destArray[1].isDisabled = false;
        })
        // changingArray[1].options = tempArray;
        // changingArray[1].isDisabled = false;
      })
    },
    getCities(valueID, clear, changingArray, filterVModelsArray){
      this.$store.dispatch("getCities",valueID).then((response) => {
        let tempArray = [];
        for(let obj of response.data){
          tempArray.push({
            value: obj.cityID,
            label: {
              ge: obj.city,
              en: obj.cityeng,
            },
          });
        }
        if(clear){
          filterVModelsArray.cityID = null;
        }
        changingArray[1].options = tempArray;
        changingArray[1].isDisabled = false;
      })
    },
    removeAriaHidden(){
      Array.from(document.querySelectorAll('.multiselect span[aria-hidden]')).forEach((item) => {
        item.removeAttribute('aria-hidden');
      })
      Array.from(document.querySelectorAll('.multiselect .multiselect-search[aria-labelledby]')).forEach((item) => {
        item.removeAttribute('aria-labelledby');
      })
    },
  },
};
</script>
<style scoped>
.home-container{
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(5, min-content);
  row-gap: 1.5em;
}

.statistics-info{
  font-size: 48px;
  font-family: "firaGo-700", Helvetica, Arial, sans-serif;
}
.supporters-map-section{
  padding: 1.5em;
  border-radius: 0.7em;
  background-color: var(--secondary-background-color);
}
.supporters-map-section .map-list-element:hover{
  background-color: var(--light-blue);
}
.supporters-map-section .map-list-element:hover > .extra-gray-color{
  color: var(--secondary-background-color);
}
.supporters-map-section .map-list-element.active{
  background-color: var(--light-blue);
}
.supporters-map-section .map-list-element.active .extra-gray-color{
  color: var(--secondary-background-color);
}
.main-info-section{
  overflow: hidden;
}
.common-table-container{
  padding: 0.5em;
  /* height: 100%; */
}
.extra-large-text{
  font-size: 24px;
}

/* for modal content >> */
.modal-form-grid-wrapper{
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  column-gap: 1em;
  row-gap: 1em;
}
.modal-form-grid-wrapper .blue-part-input{
  padding-block: 13px;
}
textarea.blue-part-input{
  width: 100%;
  resize: none;
}
.respodents-map-wrapper{
  background-color: var(--secondary-background-color);
}
/* << for modal content  */

.secondary-search-container-form{
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  gap: 2em;
  place-items: stretch start;
}
.secondary-search-container-form .primary-input{
  max-width: 360px;
}
.secondary-search-container-form .filters-wrapper{
  width: 100%;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  place-items: stretch;
  gap: 0.7em;
}
.secondary-search-container-form .right-side{
  grid-column: 5 / 6;
  grid-row: 1 / 3;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 0.7em;
}
.secondary-search-container-form .right-side > *{
  padding: 0;
}
.secondary-search-container-form .filters-wrapper .multiselect, .multiselect.custom-multiselect{
  --ms-placeholder-color: var(--light-blue);
  --ms-tag-bg: var(--light-blue);
  --ms-option-bg-selected: var(--light-blue);
  --ms-option-bg-selected-pointed: var(--light-blue);
  flex: 1;
  width: 100%;
  max-width: 360px;
  min-width: 180px;
  margin: 0;
}
.secondary-search-container-form .filters-wrapper .dp__main{
  max-width: 360px;
  --dp-input-padding: 8px 30px 8px 12px;
}


.respodent-comments-wrapper{
  padding-inline: 1em;
  height: 370px;
}
.custom-dp__main{
  --dp-input-padding: 12px 30px 12px 12px;
}


@media (max-width: 1720px) {
  .modal-form-grid-wrapper{
    gap: 0.7em;
  }
  .modal-form-grid-wrapper .blue-part-input{
    padding: 12px;
  }
  .secondary-search-container-form .filters-wrapper .dp__main{
    max-width: 360px;
    --dp-input-padding: 6px 30px 6px 12px;
  }
  .modal-form-grid-wrapper .dp__main{
    max-width: 360px;
    --dp-input-padding: 8px 30px 8px 12px;
  }
}
@media (max-width: 1560px) {
  .modal-form-grid-wrapper{
    gap: 0.5em;
  }
  .modal-form-grid-wrapper .blue-part-input{
    padding: 10px;
  }
  .respodent-comments-wrapper{
    padding-inline: 1em;
    height: 300px;
  }
  .secondary-search-container-form .filters-wrapper .dp__main{
    max-width: 360px;
    --dp-input-padding: 4px 30px 4px 12px;
  }
  .secondary-search-container-form .filters-wrapper{
    gap: 0.5em;
  }
  .secondary-search-container-form .right-side{
    display: grid;
    grid-template-rows: 1fr 1fr;
    gap: 0.5em;
  }
  .modal-form-grid-wrapper .dp__main{
    max-width: 360px;
    --dp-input-padding: 6px 30px 6px 12px;
  }
}
@media (max-width: 1400px) {
  .secondary-search-container-form{
    gap: 1em;
  }
}
@media (max-width: 1260px) {
  .secondary-search-container-form{
    grid-template-columns: 1fr;
  }
  .secondary-search-container-form .filters-wrapper{
    grid-template-columns: repeat(4, 1fr);
    grid-column: 1 / 2;
  }
  .secondary-search-container-form .right-side{
    place-items: stretch center; 
    grid-column: 1 / 5;
    grid-row: 3 / 4;
  }
  .secondary-search-container-form .right-side > *{
    max-width: 500px;
    width: 100%;
    padding: 8px 12px;
  }
}
@media (max-width: 992px) {
  .secondary-search-container-form .filters-wrapper{
    grid-column: 1 / 2;
    grid-template-columns: repeat(3, 1fr);
  }
  .secondary-search-container-form .right-side{
    place-items: stretch center; 
    grid-column: 1 / 4;
    grid-row: 4 / 5;
  }
  .respodent-comments-wrapper{
    padding-inline: 1em;
    height: 280px;
  }
}
@media (max-width: 768px) {
  .secondary-search-container-form .primary-input{
    max-width: none;
  }
  .secondary-search-container-form .filters-wrapper{
    grid-template-columns: 1fr;
  }
  .secondary-search-container-form .right-side{
    place-items: stretch center;
    grid-column: 1 / 2;
    grid-row: 9 / 10;
  }
  .secondary-search-container-form .filters-wrapper :is(.multiselect, .multiselect.custom-multiselect, .dp__main) {
    max-width: none;
  }
}
</style>
